var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('client-only',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAppMounted),expression:"isAppMounted"}],staticClass:"flex flex-col min-h-screen"},[_c('Nuxt')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }